module.exports = __webpack_public_path__ + "img/Logout.e1774f4a.svg";